import React from "react"
import { LathamAndWatkinsInformational } from "../molecules/Molecules"
import { useSelector } from "react-redux"
import { getIsLathamAndWatkinsMember, getIsCompanyUsingWINFertility } from "derivedSelectors"
import { WhatsImportantModule } from "./WhatsImportantModule"
import { HelpFindingProviderModule } from "./HelpFindingProviderModule"
import { LookingForOtherServicesModule } from "./LookingForOtherServicesModule"
import { PromotionModules } from "../molecules/PromotionModules"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"
import { Large } from "components/views/atoms/Responsive"
import { SideBarBase } from "components/views/atoms/SidebarBase"
import { CarrotAndYourHealthcareModule } from "./CarrotAndYourHealthcareModule"

const ProviderFinderSideBar = () => {
  const isLathamAndWatkinsMember = useSelector(getIsLathamAndWatkinsMember)
  const {
    featureConfig: { isCarrotRxEnabled: isCarrotRxCompany }
  } = useSelector(getBenefitConfiguration)
  const isCompanyUsingWINFertility = useSelector(getIsCompanyUsingWINFertility)

  return (
    <SideBarBase>
      {!isCarrotRxCompany && !isCompanyUsingWINFertility && (
        <Large>
          <WhatsImportantModule />
        </Large>
      )}
      {isCompanyUsingWINFertility && <CarrotAndYourHealthcareModule />}
      {isCarrotRxCompany && !isCompanyUsingWINFertility && <WhatsImportantModule />}
      <HelpFindingProviderModule />
      <PromotionModules />
      <LookingForOtherServicesModule />
      {isLathamAndWatkinsMember && <LathamAndWatkinsInformational />}
    </SideBarBase>
  )
}

export { ProviderFinderSideBar }
